<template>
  <div>
    <DeliveryBookings v-if="isAdmin"></DeliveryBookings>
  </div>
</template> 

<script>
import DeliveryBookings from "@/components/bookings/admin/DeliveryBookings";
export default {
  name: 'AdminDeliveries',
  components: { DeliveryBookings },
  data() {
    return {}
  },
  computed: {
    isAdmin() {
      return this.$store.getters['auth/isAdmin'];
    }
  }
}
</script>

<style lang="scss" scoped>

</style>